/**
 * Airport summary model containing abbreviated information about an airport
 */
export class AirportSummary {
  /**
   * Numeric identifier that uniquely identifies this airport in the database
   */
  airportId: number;

  /**
   * Source ID that identifies the source of this data (e.g., airport manager)
   */
  sourceId: number;

  /**
   * 4-letter ICAO identifier of the airport (if available)
   */
  icaoId: string;

  /**
   * 3- or 4-letter FAA identifier of the airport (if available)
   */
  faaId: string;

  /**
   * Airport name
   */
  name: string;

  /**
   * Gets the identifier that should be displayed for this airport. This will either be the ICAO identifier if
   * available, or the FAA identifier otherwise.
   */
  get identifier(): string {
    return this.icaoId || this.faaId || '';
  }

  /**
   * Parses an airport as returned by the API into an instance of the Airport class
   */
  static parse(data: any): AirportSummary {
    return Object.assign(new AirportSummary(), {
      airportId: data.airportId,
      sourceId: data.sourceId,
      icaoId: data.icaoId,
      faaId: data.faaId,
      name: data.name
    });
  }
}
